module.exports = __webpack_public_path__ + "img/alpine.ef51c99b.png";